var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.$i18n.locale === _vm.app.GLOBAL.LANG.EN
      ? _vm.chgLocate(_vm.app.GLOBAL.LANG.ZH)
      : _vm.$i18n.locale === _vm.app.GLOBAL.LANG.ZH
      ? _vm.chgLocate(_vm.app.GLOBAL.LANG.EN)
      : null}}},[_c('span',{attrs:{"title":_vm.$t('common.title_language')}},[_vm._v(_vm._s(_vm.$i18n.locale === _vm.app.GLOBAL.LANG.EN ? _vm.$t("common.zh") : _vm.$i18n.locale === _vm.app.GLOBAL.LANG.ZH ? _vm.$t("common.en") : null))])])
}
var staticRenderFns = []

export { render, staticRenderFns }